module.exports = __webpack_public_path__ + "static/img/package-img.3d60d81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/package-img.png
// module id = 6CIc
// module chunks = 1